import * as React from "react";

// icons
import "font-awesome/css/font-awesome.min.css";

// styling
import "bootstrap/dist/css/bootstrap.min.css";
import "./assessmentViewPage.css";

// toast
import "react-toastify/dist/ReactToastify.css";

// flags
import "flag-icon-css/css/flag-icon.css";

// services
import {
  createItemGen,
  createItemJson,
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded,
  setPreAssessmentComplete,
  currentDesignation,
} from "../../common/services";

// interfaces
import { IAssessmentAnswer } from "../../common/interfaces";

// components
import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";

// assessment components
import QuestionCollection from "../../common/questionCollection.Component";
import ProgressBar from "../../common/progressBar.Component";
import PLEXLoader from "../../components/PlexLoader/Loader";
import SimpleLoader from "../../components/SimpleLoader/SimpleLoader.Component";

// router
import { Redirect } from "react-router-dom";

// components
import assessmentIcon from "../../assets/images/assessment-icon.svg";
// toast component
import { toast, ToastContainer } from "react-toastify";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import CustomCheckbox from "src/common/CustomCheckbox";
import withServices from "src/HOCs/withServices";

import { SOCKET as socket } from "../../common/constants";

export interface IProps {
  activeStep: number;
  classes: any;
  theme: any;
  services: any;
}

class AssessmentViewPage extends React.Component<IProps, any> {
  public state = {
    answer: "",
    answerOptions: [],
    assessment: {},
    assessmentfields: {
      info: "assessment_info",
      questions: "questions",
      session: "assessment_session",
    },
    assessmenttitle: "",
    baseurl: currentBaseUrl(),
    counter: 0,
    currentTimeon: 0,
    interactions: 0,
    loaded: false,
    socketLoaded: false,
    assessmentProcessing: false,
    sid: null,
    question: "",
    questionId: 1,
    questiontime: new Date().getTime(),
    responses: [] as IAssessmentAnswer[],
    result: "",
    timetaken: 0,
    tocompleted: false,
    todashboard: false,
    toPreassessmentResult: false,
    tologin: false,
    toProfile: false,
    total: 0,
    submitconfirmed: false,
    submitClicked: false,
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.setUserAnswer = this.setUserAnswer.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.increaseCounterClearAns = this.increaseCounterClearAns.bind(this);
    this.loadQuestion = this.loadQuestion.bind(this);
    this.submitAnswers = this.submitAnswers.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.confirmSubmit = this.confirmSubmit.bind(this);
    this.prevButton = this.prevButton.bind(this);
    this.prevQuestion = this.prevQuestion.bind(this);
    this.onSetup = this.onSetup.bind(this);
    this.onMessage = this.onMessage.bind(this);
  }

  public onSocketConnect = (e) => {
    console.log("connected");
    console.log(e);
  };

  public onMessage(socketMessage) {
    // toast.success(`Students Assigned: ${socketMessage.message.data.total_completed}`);
    this.setState({ loaded: true, assessmentProcessing: false });

    if (socketMessage.message.status) {
      setPreAssessmentComplete();

      this.setState({ tocompleted: true, submitClicked: false });

      toast.success("Request successful");
    } else {
      toast.error("Request failed, try again");

      this.setState({ submitClicked: false });
    }
  }

  public onSetup = (message) => {
    this.setState({ sid: message.id, socketLoaded: true });
  };

  public onLogout(arg) {
    this.setState({ tologin: true });
  }

  public onProfile() {
    this.setState({ toProfile: true });
  }

  public currentid() {
    const key1 = "match";
    const params = this.props[key1].params;
    let assId = "";
    if (params.hasOwnProperty("id")) {
      assId = params.id;
    }
    return assId;
  }

  public handleGenCreatedItemLoaded(res) {
    if (res.code === 200) {
      this.setState({ loaded: false, assessmentProcessing: true });
    }
    if (res.code === 404) {
      toast.error("Request failed, try again");
      this.setState({ loaded: false });
    }
    if (res.code === 401) {
      toast.success("Request unauthorized");
      this.onLogout("arg");
    }
  }

  public async componentDidMount() {
    // socket.on('connect', this.onSocketConnect);

    // socket.on("customEmit", data => this.onSetup(data));

    // socket.on("customNotif", data => this.onMessage(data));

    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
    } else {
      const nextAssessment =
        await this.props.services.adminAPI.getNextAssessment();

      if (nextAssessment.data.status !== "available") {
        this.setState({ tologin: true });
      }

      let assID;
      if (this.currentid() !== "") {
        assID = this.currentid();
      } else {
        assID = nextAssessment.data.assessment_id;
      }

      const assessmentRes =
        await this.props.services.adminAPI.getNextAssessmentContent(assID);

      if (assessmentRes.ok) {
        this.setState({ loaded: true, assessment: assessmentRes.data });
        this.loadQuestion();
      } else {
        this.setState({ tologin: true });
      }

      this.setState({ username: currentUser() });
    }

    socket.emit("customMsg", { evt: "init" });
  }

  public handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);
  }
  public confirmSubmit() {
    this.setState((prevState) => ({
      submitconfirmed: !prevState.submitconfirmed,
    }));
  }

  public onLogoClick = () => {
    console.log("AVP logo click");
  };

  public async submitAnswers() {
    this.setState({
      loaded: false,
      submitClicked: true,
      assessmentProcessing: true,
    });

    this.generateResponse();

    const qnCount =
      this.state.assessment[this.state.assessmentfields.questions].length;

    const responseCol = [] as any;

    const answerKeys = [] as any;

    for (let i = 0; i < qnCount; i++) {
      const key = "ans_qn_" + i;

      const qnItem = sessionStorage.getItem(key) || null;

      if (qnItem) {
        responseCol.push(JSON.parse(qnItem));
        answerKeys.push(key);
      }
    }

    const item = {
      responses: responseCol,
      session: this.state.assessment[this.state.assessmentfields.session],
    };

    const submitRes =
      await this.props.services.adminAPI.submitAssessmentResponsesTextAsyn(
        item
      );

    console.log({ submitRes });

    if (submitRes.ok) {
      if (submitRes.status !== 200) {
        toast.error("Request failed, try again");
        this.setState({ loaded: false, submitClicked: false });
        return;
      }

      for (let i = 0; i < answerKeys.length; i++) {
        sessionStorage.removeItem(answerKeys[i]);
      }

      this.setState({ loaded: false, assessmentProcessing: true });

      setPreAssessmentComplete();

      setTimeout(() => {
        this.setState({ tocompleted: true, submitClicked: false });
      }, 100);
    } else {
      toast.error("Request failed, try again");
      this.setState({ loaded: false, submitClicked: false });
    }
  }

  public setUserAnswer(answer) {
    const newinteractioncount = this.state.interactions + 1;
    this.setState({
      answer: answer + "",
      interactions: newinteractioncount,
    });
  }

  public increaseCounterClearAns() {
    const newcount = this.state.counter + 1;
    this.setState({
      answer: "",
      counter: newcount,
    });
  }

  public decreaseCounterClearAns() {
    const newcount = this.state.counter - 1;
    this.setState({
      answer: "",
      counter: newcount,
    });
  }

  public loadQuestion() {
    const key = "ans_qn_" + this.state.counter;

    const existing = sessionStorage.getItem(key) || null;

    let interactions = 0;

    let answer = "";

    let currentTimeon = 0;

    if (existing) {
      try {
        const value = JSON.parse(existing);

        answer = value.answer;
        interactions = value.interactions;
        currentTimeon = value.timeon;
      } catch (e) {
        console.log("err reading saved ans");
      }
    }

    this.setState({
      answerOptions:
        this.state.assessment[this.state.assessmentfields.questions][
          this.state.counter
        ].answers,
      assessmenttitle:
        this.state.assessment[this.state.assessmentfields.info].Title,
      interactions,
      answer,
      currentTimeon,
      question:
        this.state.assessment[this.state.assessmentfields.questions][
          this.state.counter
        ].Question,
      questionId:
        this.state.assessment[this.state.assessmentfields.questions][
          this.state.counter
        ].id,
      questiontime: new Date().getTime(),
      total:
        this.state.assessment[this.state.assessmentfields.questions].length,
    });
  }

  public generateResponse() {
    const timespent =
      Math.floor(
        ((new Date().getTime() - this.state.questiontime) % (1000 * 60)) / 1000
      ) + this.state.currentTimeon;

    const key = "ans_qn_" + this.state.counter;

    const val = {
      answer: this.state.answer,
      answeredtime: new Date().getTime(),
      interactions: this.state.interactions,
      question: this.state.questionId,
      timeon: timespent,
    };

    sessionStorage[key] = JSON.stringify(val);
  }

  public nextQuestion() {
    if (
      this.state.counter <
      this.state.assessment[this.state.assessmentfields.questions].length
    ) {
      this.generateResponse();

      this.increaseCounterClearAns();
      setTimeout(() => this.loadQuestion(), 300);
    } else {
      console.log("end of list");
      // route to assessment complete page uncomment the line below
      // commented to sort the routing btn upgraded, preupgrade and lessonAssessmentResults
      this.setState({ tocompleted: true });
    }
  }

  public prevQuestion() {
    if (this.state.counter > 0) {
      this.decreaseCounterClearAns();
      setTimeout(() => this.loadQuestion(), 300);
    }
  }

  public nextButton() {
    const { submitClicked } = this.state;
    if (this.state.assessment[this.state.assessmentfields.questions]) {
      if (
        this.state.counter <
        this.state.assessment[this.state.assessmentfields.questions].length - 1
      ) {
        return (
          <button
            className="next-button"
            disabled={this.state.answer.length < 1}
            onClick={this.nextQuestion}
          >
            Next Question
          </button>
        );
      } else {
        return (
          <React.Fragment>
            <CustomCheckbox
              dispvalue="Are you 100% happy with your answers? If so, great work click the button"
              id="confirm-submit"
              type="checkbox"
              name="confirm"
              onChange={this.confirmSubmit}
            />

            <button
              className="next-button"
              style={{
                backgroundColor: submitClicked ? "#6d6d6d" : "var(--blue)",
              }}
              disabled={
                this.state.answer.length < 1 ||
                this.state.submitconfirmed === false ||
                submitClicked
              }
              onClick={this.submitAnswers}
            >
              Submit
            </button>
          </React.Fragment>
        );
      }
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <Loader color="#acff24" />
        </div>
      );
    }
  }

  public prevButton() {
    if (this.state.assessment[this.state.assessmentfields.questions]) {
      if (this.state.counter > 0) {
        return (
          <button
            className="next-button"
            onClick={this.prevQuestion}
            disabled={this.state.submitconfirmed === true}
          >
            Previous Question
          </button>
        );
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  public render() {
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }

    if (this.state.toProfile === true) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }

    if (this.state.todashboard === true) {
      return <Redirect to={this.state.baseurl + "home"} />;
    }
    if (this.state.toPreassessmentResult === true) {
      return (
        <Redirect
          to={
            this.state.baseurl + "preassessmentresult/" + currentDesignation()
          }
        />
      );
    }

    if (this.state.tocompleted === true) {
      return (
        <Redirect
          to={this.state.baseurl + "assessmentcompleted/" + this.currentid()}
        />
      );
    }

    const LoaderStyles = {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const { submitClicked } = this.state;

    return (
      <div>
        <NavBar
          logoutParent={this.onLogout}
          profileParent={this.onProfile}
          onLogoClick={this.onLogoClick}
        />
        <ToastContainer />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="assessment-main-container">
            {submitClicked ? (
              // <div style={LoaderStyles} >
              //   <PLEXLoader width={450} height={300} loaderId={1} />
              // </div>
              <SimpleLoader text="PLEX is working..." />
            ) : (
              <Loader
                loaded={this.state.loaded}
                style={{ width: "80%", overflowY: "scroll" }}
              >
                <div className="assessment-wrapper">
                  <h2 className="assessment-title">
                    {this.state.assessmenttitle}
                  </h2>
                  <div className="breadcrumb-progress-bar">
                    {/*<p className="go-back"> &lt; Back </p>*/}
                    <ProgressBar
                      fraction={this.state.counter}
                      total={this.state.total}
                      showLabel={true}
                    />
                  </div>

                  <div className="questions-container">
                    <div className="assessment-thumb">
                      <img src={assessmentIcon} alt="Icon of stationery" />
                    </div>
                    <QuestionCollection
                      answer={this.state.answer}
                      answerOptions={this.state.answerOptions}
                      questionId={this.state.questionId}
                      question={this.state.question}
                      questionTotal={this.state.total}
                      onAnswerSelected={this.handleAnswerSelected}
                      // prop for number of current qn
                      currentQuestion={this.state.counter + 1}
                    />
                  </div>
                </div>
              </Loader>
            )}

            <footer className="assessment-footer">
              {" "}
              {this.prevButton()} {this.nextButton()}
            </footer>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(AssessmentViewPage);



// WEBPACK FOOTER //
// ./src/pages/Assessments/assessmentViewPage.Component.tsx